<!--
 * @Author: ZhaoDong
 * @Date: 2022-10-24 18:57:01
 * @LastEditors: ZhaoDong
 * @LastEditTime: 2022-11-17 18:29:27
 * @Description: 发放和领取
-->
<template>
  <div>
    <a-form-model ref="ruleForm" labelAlign="right" :model="form" :rules="rules" :label-col="{ span: 4 }"
                  :wrapper-col="{ span: 16 }">
      <!-- <h3 class="label_h3">发放和领取</h3> -->
      <a-divider orientation="left">发放和领取</a-divider>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="领取方式" prop="coupon_way">
            <a-select v-model="form.coupon_way" show-search option-filter-prop="children"
                      @change="handleCouponWayChange" placeholder="请选择领取方式">
              <a-select-option v-for="(value, key) in couponWayOptions" :key="key" :value="key">
                {{ value }}
              </a-select-option>
            </a-select>
            <a-tooltip overlayClassName="tooltip-max-w700">
              <template slot="title">
                <div>
                  <p>活动页面领取：需要用户手动领取或执行特定条件进行触发;</p>
                  <p>系统自动发放：到达领取有效期时，系统自动发放至对应用户账号;</p>
                  <p>优惠码兑换：只生成发放总量的待兑换领取记录，用户兑换后可用.</p>
                </div>
              </template>
              <a-icon type="question-circle" class="question_fr" />
            </a-tooltip>
            <a-icon></a-icon>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="发放用户" prop="coupon_target">
            <a-radio-group v-model="form.coupon_target" @change="couponTargetChange">
              <div class="small-form-item">
                <a-radio value="1">所有用户</a-radio>
              </div>
              <div class="small-form-item">
                <a-radio value="2">新注册用户
                  <a-form-model-item prop="user_reg_start_at" class="small-form-item-inline">
                    <VRangePicker size="small" :showTime="showTimeConfig" :disabled="form.coupon_target !== '2'"
                                  v-model="userRegDate" />
                  </a-form-model-item>
                </a-radio>
              </div>
              <div class="small-form-item">
                <a-radio value="3">指定用户
                  <a-form-model-item prop="users" class="small-form-item-inline">
                    <!-- <span class="selected-staff-container" v-show="chooseStaffList.length">
                      <a-space>
                        <a-tag color="blue" class="tag-staff" v-for="user in chooseStaffList" :key="user.user_id">
                          {{ user.username }}
                        </a-tag>
                      </a-space>
                    </span> -->
                    <a-button style="height:19px;line-height: 19px;" :disabled="form.coupon_target !== '3'" type="link"
                              @click="openStaffModal">选择用户</a-button>
                    <span v-show="chooseStaffList.length">已选择<a>{{ chooseStaffList.length }}</a>位用户</span>
                  </a-form-model-item>
                </a-radio>
              </div>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="发放总量" prop="coupon_num" ref="coupon_num">
            <div class="flex-ac">
              <!-- <a-input-number style="width:100%;flex: 1 0 auto;" v-model="form.coupon_num" allowClear
                              :disabled="couponNumDisabled"
                              placeholder="0默认不限制数量" :precision="0" :min="0" :max="10000000" /> -->
              <a-input-number style="width:100%;flex: 1 0 auto;" v-model="couponNum" allowClear
                              :disabled="couponNumDisabled" placeholder="0默认不限制数量" :precision="0" :min="0" :max="10000000"
                              @blur="() => { $refs.coupon_num.onFieldBlur(); $refs.ruleForm.validateField(['coupon_limit']) }" />

              <span class="suffix" style="flex:1 0 auto;margin-left: 8px;">张（<span
                style="color: red;">0</span>代表不限制）</span>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="每人限领" prop="coupon_limit" ref="coupon_limit">
            <div class="flex-ac">
              <a-input-number style="width: 100%;" v-model="form.coupon_limit" allowClear placeholder="最多不超过10"
                              :precision="0" :defaultValue="1" :min="1" :max="10"
                              @blur="() => { $refs.coupon_limit.onFieldBlur(); }"/>
              <span class="suffix" style="flex:1 0 auto;margin-left: 8px;">张</span>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="领取有效期" prop="rec_start_at">
            <VRangePicker :showTime="showTimeConfig" v-model="recDate" @change="recDateChange" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="使用有效期" prop="use_type">
            <a-radio-group v-model="form.use_type" @change="useTypeChange">
              <div class="small-form-item">
                <a-radio value="1">长期有效</a-radio>
              </div>
              <div class="small-form-item">
                <a-radio value="2">固定日期
                  <a-form-model-item prop="use_eff_start_at" class="small-form-item-inline">
                    <VRangePicker size="small" :showTime="showTimeConfig" :disabled="form.use_type !== '2'"
                                  v-model="useDate" />
                  </a-form-model-item>
                </a-radio>
              </div>
              <div class="small-form-item">
                <a-radio value="3">领取后即时生效，有效天数
                  <a-form-model-item prop="use_rec_eff_day" class="small-form-item-inline">
                    <a-input-number size="small" v-model="form.use_rec_eff_day" :disabled="form.use_type !== '3'"
                                    allowClear placeholder="有效天数" :precision="0" :min="1" :max="1000" />天（最后一天零点过期）
                  </a-form-model-item>
                </a-radio>
              </div>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <!-- 选择用户 -->
    <chooseStaffModal :projectName="projectName" :brandId="project" ref="refChooseStaff" @ok="chooseStaffChange" />
  </div>
</template>

<script>
import { pick } from 'lodash'
import moment from 'moment'
import chooseStaffModal from './chooseStaffModal'
import { mapState } from "vuex"

export default {
  props: {
    project: {
      type: [String, Number],
      default: () => ''
    },
    platformList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      form: {
        coupon_way: '1', // 领取方式 1.活动页面领取 2. 系统自动发放 3. 优惠码兑换'
        coupon_target: '1', // 发放用户 1.所有用户 2. 新增注册用户 3. 指定用户'
        coupon_num: undefined, // 发放总量 0不限
        coupon_limit: 1, // 每人限领 0不限
        rec_start_at: null, // 领取有效期开始时间
        rec_end_at: null, // 领取有效期结束时间
        use_type: '1', // 使用类型 1长期有效 2固定时间 3领取后 有效天数
        use_eff_start_at: null, // 使用有效期开始时间
        use_eff_end_at: null, // 使用有效期结束时间
        use_rec_eff_day: undefined, // 领取后使用有效天数
        user_reg_start_at: undefined, // 新增注册用户开始时间
        user_reg_end_at: undefined, // 新增注册用户结束时间
        users: [] // 指定用户
      },
      rules: {
        coupon_way: [{ required: true, message: '请选择领取方式', trigger: ['change'] }],
        coupon_target: [{ required: true, message: '请选择发放用户', trigger: ['change'] }],
        // coupon_target: [{ required: true, validator: this.validCouponTarget, trigger: ['change'] }],
        // coupon_num: [{ required: true, message: '发放总量必填', trigger: ['blur'] }],
        coupon_num: [{ required: true, validator: this.validCouponNum, trigger: ['blur'] }],
        // coupon_limit: [{ required: true, message: '每人限领必填', trigger: ['blur'] }],
        coupon_limit: [{ required: true, validator: this.validCouponLimit, trigger: ['blur'] }],
        // rec_start_at: [{ required: true, message: '领取有效期必填', trigger: ['change'] }],
        rec_start_at: [{ required: true, validator: this.validRecDateDate, trigger: ['change'] }],
        use_type: [{ required: true, message: '使用有效期必填', trigger: ['change'] }],
        user_reg_start_at: [{ required: true, validator: this.validUserRegDate, trigger: ['change'] }],
        users: [{ required: true, validator: this.validUser, trigger: ['change'] }],
        use_eff_start_at: [{ required: true, validator: this.validUseDate, trigger: ['change'] }],
        use_rec_eff_day: [{ required: true, validator: this.validRecEffDay, trigger: ['change'] }]
      },
      chooseStaffList: []
    }
  },
  computed: {
    ...mapState({ labels: state => state.label.data }),
    // 领取方式
    couponWayOptions() {
      return this.labels?.COUPON_ENUM?.COUPON_WAY
    },
    // 品牌名
    projectName() {
      return this.platformList.find(item => +item.project === +this.project)?.name
    },
    showTimeConfig() {
      return {
        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
      }
    },
    // 领取有效期
    recDate: {
      get() {
        const { rec_start_at, rec_end_at } = this.form
        if (rec_start_at !== '0' && rec_end_at !== '0' && rec_start_at && rec_end_at) {
          return [+rec_start_at, +rec_end_at]
        }
        return []
      },
      set(value) {
        let start_date = null
        let end_date = null
        if (value && value.length) {
          const [_start_date, _end_date] = value
          start_date = _start_date
          end_date = _end_date
        }
        this.form.rec_start_at = start_date
        this.form.rec_end_at = end_date
      }
    },
    // 新增注册用户开始、结束日期
    userRegDate: {
      get() {
        const { user_reg_start_at, user_reg_end_at } = this.form
        if (user_reg_start_at && user_reg_end_at) {
          return [+user_reg_start_at, +user_reg_end_at]
        }
        return []
      },
      set(value) {
        let start_date = null
        let end_date = null
        if (value && value.length) {
          const [_start_date, _end_date] = value
          start_date = _start_date
          end_date = _end_date
        }
        this.form.user_reg_start_at = start_date
        this.form.user_reg_end_at = end_date
      }
    },
    // 使用有效期
    useDate: {
      get() {
        const { use_eff_start_at, use_eff_end_at } = this.form
        if (use_eff_start_at && use_eff_end_at) {
          return [+use_eff_start_at, +use_eff_end_at]
        }
        return []
      },
      set(value) {
        let start_date = null
        let end_date = null
        if (value && value.length) {
          const [_start_date, _end_date] = value
          start_date = _start_date
          end_date = _end_date
        }
        this.form.use_eff_start_at = start_date
        this.form.use_eff_end_at = end_date
      }
    },
    // 为 指定用户(3) 时，字段禁用，默认为 已选择用户数 * 每人限领
    isSpecifiedStaff() {
      const { coupon_target } = this.form
      return ['3'].includes(coupon_target)
    },
    // 为 所有用户/新注册用户 + 活动页面领取 时，字段可编辑，0≤张数＜1000w（0代表不限制）
    case1() {
      const { coupon_target, coupon_way } = this.form
      return ['1', '2'].includes(coupon_target) && ['1'].includes(coupon_way)
    },
    // 为 所有用户/新注册用户 + 系统自动发放 时，字段禁用，默认 0（0代表不限制）
    case2() {
      const { coupon_target, coupon_way } = this.form
      return ['1', '2'].includes(coupon_target) && ['2'].includes(coupon_way)
    },
    // 为 所有用户/新注册用户 + 优惠码兑换 时，字段可编辑，0＜张数＜1000w（不可设置为0）
    case3() {
      const { coupon_target, coupon_way } = this.form
      return ['1', '2'].includes(coupon_target) && ['3'].includes(coupon_way)
    },
    couponNum: {
      get() {
        if (this.isSpecifiedStaff && Array.isArray(this.form.users)) {
          this.form.coupon_num = this.form.users.length * this.form.coupon_limit
          return this.form.users.length * this.form.coupon_limit
        } else if (this.case2) {
          this.form.coupon_num = 0
        }
        return this.form.coupon_num
      },
      set(value) {
        this.form.coupon_num = value
      }
    },
    couponNumDisabled() {
      // 为 指定用户(3) 时，字段禁用，默认为 已选择用户数 * 每人限领
      // 为 所有用户/新注册用户 + 活动页面领取 时，字段可编辑，0≤张数＜1000w（0代表不限制）
      // 为 所有用户/新注册用户 + 系统自动发放 时，字段禁用，默认 0（0代表不限制）
      // 为 所有用户/新注册用户 + 优惠码兑换 时，字段可编辑，0＜张数＜1000w（不可设置为0）
      return this.isSpecifiedStaff || this.case2
    }
  },
  methods: {
    recDateChange() {
      this.$refs.ruleForm.validateField(['use_eff_start_at'])
    },
    validCouponTarget(rule, value, callback) {
      if (!this.form.coupon_target) return callback(new Error('请选择发放用户'))
      // 新注册用户，时间段必填
      if (this.form.coupon_target === '2' && !this.form.user_reg_start_at) {
        return callback(new Error('请选择注册时间段'))
      } else if (this.form.coupon_target === '3' && this.form.users && this.form.users.length === 0) {
        return callback(new Error('请指定用户'))
      }
      callback()
    },
    validUser(rule, value, callback) {
      // 新注册用户，时间段必填
      if (this.form.coupon_target === '3' && this.form.users && this.form.users.length === 0) {
        return callback(new Error('请指定用户'))
      }
      callback()
    },
    validRecEffDay(rule, value, callback) {
      if (this.form.use_type === '3' && !this.form.use_rec_eff_day) {
        return callback(new Error('有效天数必填'))
      }
      callback()
    },
    validUseDate(rule, value, callback) {
      if (this.form.use_type === '2') {
        const { rec_start_at, rec_end_at, use_eff_start_at, use_eff_end_at } = this.form
        if (!this.form.use_eff_start_at) {
          return callback(new Error('请选择使用有效期时间段'))
        } else if (rec_start_at && rec_end_at && (use_eff_start_at < rec_start_at || use_eff_end_at < rec_end_at)) {
          return callback(new Error('使用有效期时间必须>=领取开始时间且>=领取结束时间'))
        }
      }
      callback()
    },
    validUserRegDate(rule, value, callback) {
      // 新注册用户，时间段必填
      if (this.form.coupon_target === '2' && !this.form.user_reg_start_at) {
        return callback(new Error('新注册用户时间段必填'))
      }
      callback()
    },
    validCouponLimit(rule, value, callback) {
      const { coupon_limit, coupon_num } = this.form
      if (!coupon_limit) {
        return callback(new Error('发放总量必填'))
      } else if (+coupon_num !== 0 && +coupon_limit > +coupon_num) {
        return callback(new Error('每人限领张数必须<=发放总量'))
      } else if (+coupon_limit > 10 || +coupon_limit < 1) {
        return callback(new Error('1≤每人限领≤10'))
      }
      callback()
    },
    validRecDateDate(rule, value, callback) {
      const { rec_start_at, rec_end_at } = this.form
      if (!this.form.rec_start_at) {
        return callback(new Error('领取有效期必填'))
      } else if (!!rec_start_at && !!rec_end_at && (rec_end_at < moment().unix()) || rec_end_at <= rec_start_at) {
        return callback(new Error('结束时间：需大于开始时间且大于当前时间'))
      }
      callback()
    },
    validCouponNum(rule, value, callback) {
      if (value === null || value === undefined) {
        return callback(new Error('发放总量必填'))
      } else if (this.case1 && (value < 0 || value >= 10000000)) {
        return callback(new Error('发放总量必须>=0且<1000w'))
      } else if (this.case2 && value !== 0) {
        return callback(new Error('发放总量必须为0'))
      } else if (this.case3 && (value <= 0 || value >= 10000000)) {
        return callback(new Error('发放总量必须>0且<1000w'))
      }
      callback()
    },
    useTypeChange() {
      switch (this.form.use_type) {
        case '1':
          this.useDate = []
          this.form.use_rec_eff_day = null
          break
        case '2':
          this.form.use_rec_eff_day = null
          break
        case '3':
          this.useDate = []
          break
        default:
          break
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField(['use_eff_start_at', 'use_rec_eff_day'])
      })
    },
    couponTargetChange() {
      switch (this.form.coupon_target) {
        case '1':
          this.userRegDate = []
          this.form.users = []
          this.chooseStaffList = []
          break
        case '2':
          this.form.users = []
          this.chooseStaffList = []
          break
        case '3':
          this.userRegDate = []
          break
        default:
          break
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField(['user_reg_start_at', 'users', 'coupon_num'])
      })
    },
    /**
     * 领取方式 Change
     */
    handleCouponWayChange() {
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField(['coupon_target', 'coupon_num', 'user_reg_start_at', 'users'])
      })
    },
    openStaffModal() {
      // this.form.users
      this.$refs.refChooseStaff.open(this.chooseStaffList)
    },
    chooseStaffChange(users) {
      this.chooseStaffList = users
      this.form.users = users.map(item => item.user_id)
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField(['coupon_num', 'users'])
      })
    },
    async validate() {
      const valid = await this.$refs['ruleForm'].validate()
      return valid
    },
    /**
     * 自定义校验空值
     * @return Promise<true|false>
     */
    validNotEmptyFields() {
      let validFields = []
      const { coupon_target, use_type } = this.form
      const _rulesKeys = Object.keys(this.rules)
      for (const key of _rulesKeys) {
        const filedValue = this.form[key]
          if (filedValue !== null && filedValue !== undefined && filedValue !== '') {
            validFields.push(key)
          }
      }

      if (coupon_target === '2') {
        validFields.push('user_reg_start_at')
      } else if (coupon_target === '3') {
        validFields.push('users')
      }
      if (use_type === '2') {
        validFields.push('use_eff_start_at')
      } else if (use_type === '3') {
        validFields.push('use_rec_eff_day')
      }
      validFields = [...new Set(validFields)]
      let failCount = 0; let validCount = 0
      const failFields = []
      return new Promise((resolve, reject) => {
        this.$refs['ruleForm'].validateField(validFields, (err) => {
          validCount++
          if (err) {
            failFields.push(validFields[validCount])
            failCount += 1
          }
          if (validCount === validFields.length) {
            failCount > 0 ? resolve(false) : resolve(true)
          }
        })
      })
    },
    async getValue(valid) {
      return new Promise((resolve, reject) => {
        if (valid) {
          this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
              resolve({ ...this.form })
            } else {
              reject(new Error('valid fail'))
            }
          })
        } else {
          resolve({ ...this.form })
        }
      })
    },
    setValue(data) {
      const _formData = pick.apply(undefined, [data].concat(Object.keys(this.form)))
      const { coupon_limit, rec_start_at, rec_end_at, user_reg_start_at, user_reg_end_at, use_eff_start_at, use_eff_end_at } = _formData
      // 处理日期为 '0' 的情况
      if (rec_start_at === '0' || rec_end_at === '0') {
        _formData.rec_start_at = undefined
        _formData.rec_end_at = undefined
      }
      if (user_reg_start_at === '0' || user_reg_end_at === '0') {
        _formData.user_reg_start_at = undefined
        _formData.user_reg_end_at = undefined
      }
      if (use_eff_start_at === '0' || use_eff_end_at === '0') {
        _formData.use_eff_start_at = undefined
        _formData.use_eff_end_at = undefined
      }
      if (+coupon_limit === 0) {
        _formData.coupon_limit = 1
      }

      _formData.coupon_way = _formData.coupon_way === '0' ? undefined : _formData.coupon_way
      _formData.use_rec_eff_day = _formData.use_rec_eff_day === '0' ? undefined : _formData.use_rec_eff_day
      this.form = _formData

      if (Array.isArray(data.useUsers)) {
        this.form.users = data.useUsers.map(m => (m.user_id))
        this.chooseStaffList = data.useUsers.map(m => {
          return {
            user_id: m.user_id,
            mobile: m.userInfo?.mobile,
            real_name: m.userInfo?.real_name,
            username: m.userInfo?.username,
          }
        })
      } else {
        this.form.users = []
        this.chooseStaffList = []
      }
    },
    resetForm() {
      this.$refs['ruleForm'].resetFields()
    }
  },
  components: {
    chooseStaffModal
  }
}
</script>

<style scoped lang="less">
.question_fr {
  position: absolute;
  right: -24px;
  top: 0px;
}
</style>
<style>
.tooltip-max-w700 {
  max-width: 700px !important;
}
</style>
